<template>    
    <div class="flash-position transition" role="alert" v-show="show">
      <div class="alert alert-success" role="alert">
        <span class="alert-note"><i aria-hidden="true" class="material-icons">star</i></span>
        <span class="font-semibold mr-2 text-left flex-auto">{{ body }}</span>
      </div>
    </div>
</template>

<script>
    export default {
        props: ['message'],
        data() {
            return {
                show : false,
                body : ''
            }
        },
        created() {
            if(this.message) {
                this.flash(this.message)
            }
        },
        methods: {
            flash(message) {
                this.show = true
                this.body = message
                
                setTimeout(() => {
                    this.hide()
                },4000)
            },
            hide() {
                this.show = false
            }
        }
    };
</script>
